import React from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./StatusModal.css";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BlueBorderBtn from "../../common_btn/blueBorderBtn/BlueBorderBtn";
import Success_Lottie from "../../../assets/animation/success_lottie/Success_Lottie";

const StatusModal = ({
  show = true,
  onHide,
  title = "Update Basic Details",
  statusTitle = "Basic Details Updated",
  message = "Basic Details has been updated successfully and the admin has been notified.",
  buttonText = "Done",
  onButtonClick,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="StatusModal common_modal"
    >
      {/* Header Section */}
      <Modal.Header closeButton>
        <div className="d-flex align-items-center gap-2">
          <button
            className="back-btn border-0"
            onClick={onHide}
            aria-label="Back"
          >
            <span className="back-arrow">
              <FontAwesomeIcon icon={faCaretLeft} />
            </span>
          </button>

          <Modal.Title className="modal-custom-title">{title}</Modal.Title>
        </div>
      </Modal.Header>

      {/* Body Section */}
      <Modal.Body className="modal-custom-body text-center p-4">
        {/* Success Circle Icon */}
        <Success_Lottie />

        {/* Text Content */}
        <h5 className="status-title mb-2">{statusTitle}</h5>
        <p className="status-message mx-auto mb-4">{message}</p>

        {/* Action Button */}

        <BlueBorderBtn btnText={buttonText} onClick={onButtonClick || onHide} />
      </Modal.Body>
    </Modal>
  );
};

export default StatusModal;
